export default function SectionHeading({ eyebrow, title, subtitle, align = "center", light = false }) {
  const alignCls = align === "left" ? "text-left items-start" : "text-center items-center";
  return (
    <div className={`flex flex-col ${alignCls} max-w-3xl ${align === "center" ? "mx-auto" : ""} mb-14`}>
      {eyebrow && (
        <div className={`font-hand text-2xl mb-2 ${light ? "text-brand-light" : "text-brand"}`}>
          {eyebrow}
        </div>
      )}
      <h2 className={`font-display text-4xl md:text-5xl lg:text-6xl font-semibold leading-[1.05] ${light ? "text-cream" : "text-granite-dark"}`}>
        {title}
      </h2>
      {subtitle && (
        <p className={`mt-5 text-base md:text-lg leading-relaxed ${light ? "text-cream/80" : "text-granite/70"}`}>
          {subtitle}
        </p>
      )}
      <div className="flex items-center gap-2 mt-6">
        <span className={`w-6 h-[2px] ${light ? "bg-brand-light" : "bg-brand"}`} />
        <span className={`w-2 h-2 rounded-full ${light ? "bg-brand-light" : "bg-brand"}`} />
        <span className={`w-6 h-[2px] ${light ? "bg-brand-light" : "bg-brand"}`} />
      </div>
    </div>
  );
}
